import React, { useEffect, useRef } from 'react';
import WelcomePageBanner from "../../assets/images/WelcomePageBanner.png";
import Footer from './Footer';
import Navbar from '../Header/Navbar';
import { TbArrowBackUp } from 'react-icons/tb';
import { Link, useNavigate } from 'react-router-dom';

function Conditions() {
    const scrollableRef = useRef(null);
    const navigate = useNavigate()
    useEffect(() => {
        if (scrollableRef.current) {
            scrollableRef.current.focus();
        }
    }, []);
    return (
        <>
            {/* <Navbar></Navbar> */}
            <section
            ref={scrollableRef}
            tabIndex={0}
                className="h-[100vh]  bg-white overflow-auto relative"
                style={{
                    background: `url(${WelcomePageBanner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    height: "100vh", 
                }}
            >
                <Link
                          onClick={()=>navigate(-1)}
                          className="absolute top-2 left-2 flex items-center justify-center bg-black/20 rounded-full p-2.5 cursor-pointer"
                          title="Se déconnecter"
                        >
                          <TbArrowBackUp size={"26px"} className="text-orange-500" />
                        </Link>
                <div className="max-w-5xl mx-auto my-7 bg-white/5 rounded-lg backdrop-blur-xl text-white p-6 ">
                    <h1 className="text-3xl my-5 text-center font-bold mb-4">Conditions Générales de Vente (CGV) de Maya+</h1>
                    <h2 className="text-2xl font-semibold mt-8 mb-2">1. Informations légales</h2>
                    <p>La plateforme Maya+ est exploitée par la société Studio Raneem, dont le siège social est situé rue du Four à Chaux, 62223 Sainte Catherine, France, immatriculée au RCS d’ARRAS sous le numéro SIRET 88401262600021. Pour toute question ou demande d'information, vous pouvez nous contacter par e-mail à l'adresse suivante :  <a href="mailto:contact@studioraneem.com" className="text-blue-500 underline">contact@studioraneem.com</a>. Pour le service client de Maya+, veuillez nous contacter à l'adresse : <a href="mailto:contact@mayaplus.fr" className="text-blue-500 underline">contact@mayaplus.fr</a>.</p>
                    <h2 className="text-2xl font-semibold mt-4 mb-2">2. Description des services</h2>
                    <p>Maya+ est une plateforme de vidéo à la demande accessible via le site web www.mayaplus.fr et les applications mobiles iOS et Android. Nous proposons une large gamme de films, séries, émissions, dessins animés, documentaires et fictions adaptés pour toute la famille. Les services sont uniquement disponibles pour les résidents en France.</p>
                    <h2 className="text-2xl font-semibold mt-4 mb-2">3. Conditions d'accès et d’utilisation</h2>
                    <p>Pour s’abonner à Maya+, vous devez avoir au moins 18 ans et résider en France. L'abonnement est facturé à 9,99€ par mois et par foyer. Il est sans engagement et peut être annulé à tout moment.</p>
                    <h2 className="text-2xl font-semibold mt-4 mb-2">4. Propriété intellectuelle</h2>
                    <p>Les contenus disponibles sur Maya+ sont protégés par le droit d'auteur. Il est strictement interdit de reproduire, diffuser ou utiliser de quelque manière que ce soit les contenus, en tout ou en partie, sans l’autorisation expresse de Maya+.</p>
                    <h2 className="text-2xl font-semibold mt-4 mb-2">5. Résiliation et suspension</h2>
                    <p>L'abonnement peut être résilié à tout moment depuis l'espace personnel de l'utilisateur sur le site ou les applications mobiles. Maya+ se réserve également le droit de suspendre ou résilier l’accès aux services en cas de violation des présentes CGV.</p>
                    <h2 className="text-2xl font-semibold mt-4 mb-2">6. Limitation de responsabilité et garanties</h2>
                    <p>Maya+ met tout en œuvre pour assurer la disponibilité et la qualité de ses services. Toutefois, la société Studio Raneem ne peut être tenue responsable des éventuels dysfonctionnements, bugs ou interruptions des services.</p>
                    <h2 className="text-2xl font-semibold mt-4 mb-2">7. Loi applicable et juridiction compétente</h2>
                    <p>Les présentes CGV sont régies par le droit français. Tout litige relatif à leur interprétation, leur exécution ou leur validité sera soumis à la compétence exclusive des tribunaux français.</p>
                    <h2 className="text-2xl font-semibold mt-4 mb-2">8. Modifica tions des CGV</h2>
                    <p>Maya+ se réserve le droit de modifier les présentes CGV à tout moment. Les utilisateurs seront informés de ces modifications et devront les accepter pour continuer à utiliser les services.</p>
                </div>
                <div className='bg-[#151226]'>
                    <Footer></Footer>
                </div>

            </section>

        </>
    );
}

export default Conditions;
